export default __webpack_public_path__ + "static/media/delete-modal.bec1fc7e.svg";